/* EOS Visors — fitment finder & garage  v1.0
   ---------------------------------------------------------------------------
   Cascade : Year -> Make -> Model -> Body (Body only appears when the chosen
             model actually comes in more than one body style)
   LIVE    : /collections/all?view=eos-json  (Shopify storefront filters)
   STATIC  : window.EOS_FIT = [[y1,y2,make,model,body,handle,install], ...]
   Storage : eos_garage = {"y":2015,"mk":"Honda","md":"Civic","bd":"Coupe"}
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'eos_garage', RENDER_SEQ = 0;
  var ENDPOINT = '/collections/all?view=eos-json';
  var P_YEAR = 'filter.p.m.fitment.years';
  var P_MAKE = 'filter.p.m.fitment.make';
  var DATA = window.EOS_FIT || [];
  var MODE = 'static', BOOT = null, CACHE = {}, BUCKET = {};

  /* ---------------- storage ---------------- */
  function get() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return (v && v.y && v.mk && v.md) ? v : null; }
    catch (e) { return null; }
  }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function label(g) { return g ? (g.y + ' ' + g.mk + ' ' + g.md + (g.bd ? ' ' + g.bd : '')) : ''; }
  function cmp(a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  /* ---------------- live fetch ---------------- */
  function pull(url) {
    if (CACHE[url]) return Promise.resolve(CACHE[url]);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.ok) { CACHE[url] = j; return j; } return null; })
      .catch(function () { return null; });
  }
  function filterOf(p, param) {
    if (!p || !p.filters) return null;
    for (var i = 0; i < p.filters.length; i++) if (p.filters[i].param === param) return p.filters[i];
    return null;
  }
  function urlFor(year, make) {
    var u = ENDPOINT;
    if (year) u += '&' + P_YEAR + '=' + encodeURIComponent(year);
    if (make) u += '&' + P_MAKE + '=' + encodeURIComponent(make);
    return u;
  }
  function listOf(s) {
    return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  /* ---------------- data access (live or static) ---------------- */
  function getYears() {
    if (MODE === 'live') {
      var f = filterOf(BOOT, P_YEAR);
      var out = f ? f.values.map(function (v) { return v.v; }) : [];
      return Promise.resolve(out.sort(function (a, b) { return (+b) - (+a); }));
    }
    var s = {}, i, y;
    for (i = 0; i < DATA.length; i++) for (y = DATA[i][0]; y <= DATA[i][1]; y++) s[y] = 1;
    return Promise.resolve(Object.keys(s).sort(function (a, b) { return b - a; }));
  }
  function getMakes(year) {
    if (MODE === 'live') {
      return pull(urlFor(year, null)).then(function (j) {
        var f = filterOf(j, P_MAKE);
        return f ? f.values.map(function (v) { return v.v; }).sort(cmp) : [];
      });
    }
    var s = {}, i; year = +year;
    for (i = 0; i < DATA.length; i++) if (year >= DATA[i][0] && year <= DATA[i][1]) s[DATA[i][2]] = 1;
    return Promise.resolve(Object.keys(s).sort(cmp));
  }
  /* 一次過攞返 year+make 嘅產品，型號同車身都由呢度出 */
  function bucket(year, make) {
    var k = year + '|' + make;
    if (BUCKET[k]) return Promise.resolve(BUCKET[k]);
    if (MODE === 'live') {
      return pull(urlFor(year, make)).then(function (j) {
        var list = (j && j.products) || [];
        BUCKET[k] = list;
        return list;
      });
    }
    var out = [], i, y = +year;
    for (i = 0; i < DATA.length; i++) {
      var e = DATA[i];
      if (e[2] === make && y >= e[0] && y <= e[1])
        out.push({ h: e[5], t: '', m: e[3], b: e[4] || '', inst: e[6] || '', price: null, varies: false, img: '', _static: true });
    }
    BUCKET[k] = out;
    return Promise.resolve(out);
  }
  function getModels(year, make) {
    return bucket(year, make).then(function (list) {
      var s = {}, i, j, parts;
      for (i = 0; i < list.length; i++) {
        parts = listOf(list[i].m);
        for (j = 0; j < parts.length; j++) s[parts[j]] = 1;
      }
      return Object.keys(s).sort(cmp);
    });
  }
  function forModel(year, make, model) {
    return bucket(year, make).then(function (list) {
      return list.filter(function (p) { return listOf(p.m).indexOf(model) !== -1; });
    });
  }
  /* 車身款式：得一個（或者冇）就唔使出第四個掣 */
  function getBodies(year, make, model) {
    return forModel(year, make, model).then(function (list) {
      var s = {}, i;
      for (i = 0; i < list.length; i++) if (list[i].b) s[list[i].b] = 1;
      var b = Object.keys(s).sort(cmp);
      return (b.length > 1) ? b : [];
    });
  }
  function getMatches(g) {
    if (!g) return Promise.resolve([]);
    return forModel(g.y, g.mk, g.md).then(function (list) {
      if (!g.bd) return list;
      return list.filter(function (p) { return !p.b || p.b === g.bd; });
    });
  }

  /* ---------------- fit check ---------------- */
  function fitsProduct(g, box) {
    if (!g) return null;
    var mk = listOf(box.getAttribute('data-eos-make'));
    var md = listOf(box.getAttribute('data-eos-model'));
    var ys = listOf(box.getAttribute('data-eos-years'));
    var bd = (box.getAttribute('data-eos-body') || '').trim();
    if (mk.length) {
      if (mk.indexOf(g.mk) === -1) return false;
      if (md.length && md.indexOf(g.md) === -1) return false;
      if (bd && g.bd && bd !== g.bd) return false;
      if (ys.length) return ys.indexOf(String(g.y)) !== -1;
      return true;
    }
    var h = box.getAttribute('data-eos-handle'), e = [], j;
    for (j = 0; j < DATA.length; j++) if (DATA[j][5] === h) e.push(DATA[j]);
    if (!e.length) return null;
    for (j = 0; j < e.length; j++)
      if (e[j][2] === g.mk && e[j][3] === g.md && g.y >= e[j][0] && g.y <= e[j][1] &&
          (!e[j][4] || !g.bd || e[j][4] === g.bd)) return true;
    return false;
  }
  function coversText(box) {
    var mk = listOf(box.getAttribute('data-eos-make'));
    var md = listOf(box.getAttribute('data-eos-model'));
    var ys = listOf(box.getAttribute('data-eos-years'));
    var bd = (box.getAttribute('data-eos-body') || '').trim();
    if (mk.length) {
      var yr = ys.length ? ys[0] + '-' + ys[ys.length - 1] + ' ' : '';
      return (yr + mk.join(' / ') + ' ' + md.join(' / ') + (bd ? ' ' + bd : '')).trim();
    }
    var h = box.getAttribute('data-eos-handle'), s = [], i;
    for (i = 0; i < DATA.length; i++)
      if (DATA[i][5] === h)
        s.push(DATA[i][0] + '-' + DATA[i][1] + ' ' + DATA[i][2] + ' ' + DATA[i][3] + (DATA[i][4] ? ' ' + DATA[i][4] : ''));
    return s.join(', ');
  }

  /* ---------------- selects ---------------- */
  function fill(sel, arr, ph) {
    var h = '<option value="">' + ph + '</option>', i;
    for (i = 0; i < arr.length; i++) h += '<option value="' + esc(arr[i]) + '">' + esc(arr[i]) + '</option>';
    sel.innerHTML = h;
  }
  function busy(sel) { sel.disabled = true; sel.innerHTML = '<option value="">Loading…</option>'; }
  function showBody(root, on) {
    var wrap = root.querySelector('[data-eos-bodywrap]');
    if (wrap) wrap.hidden = !on;
  }

  function wire(root, onReady) {
    var yS = root.querySelector('[data-eos-year]'),
        mS = root.querySelector('[data-eos-make]'),
        dS = root.querySelector('[data-eos-model]'),
        bS = root.querySelector('[data-eos-body]'),
        go = root.querySelector('[data-eos-go]');
    if (!yS || !mS || !dS) return;

    function state() {
      var needBody = bS && !bS.disabled && bS.options.length > 1 &&
                     !(root.querySelector('[data-eos-bodywrap]') || {}).hidden;
      var ok = yS.value && mS.value && dS.value && (!needBody || bS.value);
      if (go) go.disabled = !ok;
      return ok;
    }

    getYears().then(function (ys) { fill(yS, ys, 'Year'); restore(); });

    yS.addEventListener('change', function () {
      fill(dS, [], 'Model'); dS.disabled = true;
      if (bS) { fill(bS, [], 'Body'); bS.disabled = true; } showBody(root, false);
      if (!yS.value) { fill(mS, [], 'Make'); mS.disabled = true; state(); return; }
      busy(mS);
      getMakes(yS.value).then(function (mk) { fill(mS, mk, 'Make'); mS.disabled = false; state(); });
    });

    mS.addEventListener('change', function () {
      if (bS) { fill(bS, [], 'Body'); bS.disabled = true; } showBody(root, false);
      if (!mS.value) { fill(dS, [], 'Model'); dS.disabled = true; state(); return; }
      busy(dS);
      getModels(yS.value, mS.value).then(function (md) { fill(dS, md, 'Model'); dS.disabled = false; state(); });
    });

    dS.addEventListener('change', function () {
      if (!bS) { state(); return; }
      fill(bS, [], 'Body'); bS.disabled = true; showBody(root, false);
      if (!dS.value) { state(); return; }
      getBodies(yS.value, mS.value, dS.value).then(function (bd) {
        if (bd.length) { fill(bS, bd, 'Body style'); bS.disabled = false; showBody(root, true); }
        state();
      });
    });

    if (bS) bS.addEventListener('change', state);

    function restore() {
      var g = get();
      if (!g) { state(); return; }
      yS.value = g.y;
      if (!yS.value) { state(); return; }
      busy(mS);
      getMakes(g.y).then(function (mk) {
        fill(mS, mk, 'Make'); mS.disabled = false; mS.value = g.mk;
        if (!mS.value) { state(); return; }
        busy(dS);
        return getModels(g.y, g.mk).then(function (md) {
          fill(dS, md, 'Model'); dS.disabled = false; dS.value = g.md;
          if (!dS.value || !bS) { state(); return; }
          return getBodies(g.y, g.mk, g.md).then(function (bd) {
            if (bd.length) { fill(bS, bd, 'Body style'); bS.disabled = false; showBody(root, true); bS.value = g.bd || ''; }
            state();
          });
        });
      });
    }

    if (go) go.addEventListener('click', function () {
      if (!state()) return;
      var v = { y: +yS.value, mk: mS.value, md: dS.value };
      if (bS && bS.value) v.bd = bS.value;
      set(v); paintGarage();
      if (onReady) onReady(v, root);
    });
  }

  /* ---------------- results ---------------- */
  function money(c) {
    if (c === null || c === undefined) return '';
    try {
      return (c / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function card(p, g, wide) {
    var a = document.createElement('a');
    a.className = 'eos-card';
    a.href = '/products/' + p.h;
    var sub = [];
    if (p.inst) sub.push(p.inst);
    sub.push(esc(label(g)));
    a.innerHTML =
      (p.img ? '<span class="eos-cimg"><img loading="lazy" src="' + p.img + '" alt="' + esc(p.t) +
               '" width="600" height="600"></span>' : '') +
      '<span class="eos-cb"><span class="eos-badge">Fits your car</span>' +
      '<span class="eos-ct">' + esc(p.t) + '</span>' +
      (wide ? '<span class="eos-cd">' + sub.join(' &middot; ') + '</span>'
            : (p.inst ? '<span class="eos-cd eos-cd--tag">' + esc(p.inst) + '</span>' : '')) +
      '<span class="eos-crow"><span class="eos-cp">' +
      (p.price === null ? '' : (p.varies ? 'from ' : '') + money(p.price)) + '</span>' +
      (wide ? '<span class="eos-cgo">View product &rarr;</span>' : '') + '</span></span>';
    return a;
  }
  function hydrate(grid, p, g, wide, seq) {
    var slot = document.createElement('div');
    slot.className = 'eos-slot';
    grid.appendChild(slot);
    fetch('/products/' + p.h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (seq !== RENDER_SEQ) return;
        if (!j) { slot.remove(); return; }
        slot.replaceWith(card({
          h: j.handle, t: j.title, price: j.price, varies: j.price_varies, inst: p.inst,
          img: j.featured_image ? j.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : ''
        }, g, wide));
      })
      .catch(function () { if (seq === RENDER_SEQ) slot.remove(); });
  }

  function render(box, g, jump) {
    var seq = ++RENDER_SEQ;
    box.innerHTML = '<h3>Checking your ' + esc(label(g)) + ' <span class="eos-spin"></span></h3>' +
                    '<div class="eos-cards"><div class="eos-slot"></div></div>';
    getMatches(g).then(function (list) {
      if (seq !== RENDER_SEQ) return;
      if (!list.length) {
        box.innerHTML = '<div class="eos-empty"><b>We don\'t have visors listed for the ' +
          esc(label(g)) + ' yet.</b><br>Tell us and we\'ll check — most requests come back within 48 hours. ' +
          '<a class="eos-link" href="/pages/contact">Request this fitment &rarr;</a></div>';
        return;
      }
      if (jump && list.length === 1) { window.location.href = '/products/' + list[0].h; return; }
      var mode = (box.closest('[data-eos-finder]') || {}).getAttribute
                 ? box.closest('[data-eos-finder]').getAttribute('data-eos-layout') : null;
      var wide = (mode === 'list') ? true : (mode === 'grid') ? false : (list.length <= 3);
      box.innerHTML = '<h3>Fits your ' + esc(label(g)) + '</h3>' +
        '<div class="eos-cards' + (wide ? ' eos-cards--wide' : '') + '"></div>';
      var grid = box.querySelector('.eos-cards');
      list.forEach(function (p) {
        if (p._static) hydrate(grid, p, g, wide, seq);
        else grid.appendChild(card(p, g, wide));
      });
    });
  }

  /* ---------------- garage + fit ---------------- */
  function paintGarage() {
    var g = get();
    document.querySelectorAll('[data-eos-garage]').forEach(function (bar) {
      var chip = bar.querySelector('[data-eos-chip]');
      if (chip) {
        chip.className = 'eos-chip' + (g ? '' : ' is-empty');
        chip.innerHTML = '<span class="eos-dot" aria-hidden="true"></span>' +
          '<span class="eos-lbl">Garage</span><span>' + (g ? esc(label(g)) : 'No vehicle selected') + '</span>';
      }
      var btn = bar.querySelector('[data-eos-change]');
      if (btn) btn.textContent = g ? 'Change vehicle' : 'Select your vehicle';
      var cl = bar.querySelector('[data-eos-clear]');
      if (cl) cl.hidden = !g;
    });
    document.querySelectorAll('[data-eos-fitcheck]').forEach(paintFit);
  }
  function paintFit(box) {
    var g = get(), v = fitsProduct(g, box), covers = coversText(box);
    var inst = (box.getAttribute('data-eos-install') || '').trim();
    if (!g) {
      box.className = 'eos-fit eos-fit--ask';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#128663;</span><div><b>Will these fit my car?</b>' +
        (covers ? 'Cut for the ' + esc(covers) + '. ' : '') +
        '<button type="button" class="eos-link" data-eos-change>Select your vehicle to confirm</button></div>';
    } else if (v === true) {
      box.className = 'eos-fit eos-fit--yes';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#9989;</span><div><b>Confirmed fit &mdash; ' +
        esc(label(g)) + '</b>Cut for your exact window line.' + (inst ? ' ' + esc(inst) + ' install.' : '') + '</div>';
    } else if (v === false) {
      box.className = 'eos-fit eos-fit--no';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#9888;</span><div><b>These are not for your ' +
        esc(label(g)) + '</b>' + (covers ? 'They fit the ' + esc(covers) + '. ' : '') +
        '<button type="button" class="eos-link" data-eos-change>Find the visors for my car</button></div>';
    } else {
      box.className = 'eos-fit eos-fit--ask';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#128663;</span><div><b>Fitment not listed for this product</b>' +
        'Check the title, or <a class="eos-link" href="/pages/contact">ask us</a> before you order.</div>';
    }
  }


  /* ---------------- browse by brand / model ---------------- */
  var P_MODEL = 'filter.p.m.fitment.model';

  function browseValues(source) {
    var param = (source === 'model') ? P_MODEL : P_MAKE;
    if (MODE === 'live') {
      var f = filterOf(BOOT, param);
      if (f && f.values && f.values.length)
        return f.values.map(function (v) { return { v: v.v, n: v.n }; }).sort(function (a, b) { return cmp(a.v, b.v); });
    }
    var idx = (source === 'model') ? 3 : 2;   // 靜態表：2=make 3=model
    var tally = {}, seen = {}, i, key;
    for (i = 0; i < DATA.length; i++) {
      key = DATA[i][idx] + '|' + DATA[i][5];   // 同一件貨喺同一個值下面只計一次
      if (seen[key]) continue;
      seen[key] = 1;
      tally[DATA[i][idx]] = (tally[DATA[i][idx]] || 0) + 1;
    }
    return Object.keys(tally).map(function (k) { return { v: k, n: tally[k] }; })
                 .sort(function (a, b) { return cmp(a.v, b.v); });
  }

  function browseHref(source, value) {
    var param = (source === 'model') ? P_MODEL : P_MAKE;
    return '/collections/all?' + param + '=' + encodeURIComponent(value);
  }

  function paintBrowse(box) {
    var source = box.getAttribute('data-eos-browse') || 'make';
    var limit  = parseInt(box.getAttribute('data-eos-limit') || '0', 10);
    var counts = box.getAttribute('data-eos-counts') !== 'false';
    var list   = browseValues(source);

    if (!list.length) { box.innerHTML = ''; return; }

    box.innerHTML = list.map(function (item, i) {
      return '<a class="eos-bt" href="' + browseHref(source, item.v) + '"' +
             (limit && i >= limit ? ' hidden data-eos-extra' : '') +
             ' data-eos-label="' + esc(item.v).toLowerCase() + '">' +
             '<span class="eos-bt__t">' + esc(item.v) + '</span>' +
             (counts ? '<span class="eos-bt__n">' + item.n + '</span>' : '') + '</a>';
    }).join('');

    var wrap = box.closest('.eos') || document;
    var more = wrap.querySelector('[data-eos-browse-more]');
    if (more) {
      var hidden = box.querySelectorAll('[data-eos-extra]').length;
      more.hidden = hidden === 0;
      more.onclick = function () {
        box.querySelectorAll('[data-eos-extra]').forEach(function (el) { el.hidden = false; });
        more.hidden = true;
      };
    }
    var search = wrap.querySelector('[data-eos-browse-search]');
    if (search) {
      search.oninput = function () {
        var q = search.value.trim().toLowerCase();
        var shown = 0;
        box.querySelectorAll('.eos-bt').forEach(function (el) {
          var hit = !q || el.getAttribute('data-eos-label').indexOf(q) !== -1;
          el.hidden = !hit;
          if (hit) shown++;
        });
        if (more) more.hidden = true;
        box.classList.toggle('is-empty', shown === 0);
      };
    }
  }

  /* ---------------- modal + init ---------------- */
  var modal;
  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open'); document.body.style.overflow = 'hidden';
    var f = modal.querySelector('[data-eos-year]'); if (f) f.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open'); document.body.style.overflow = '';
  }
  function flash(box) { box.classList.remove('eos-flash'); void box.offsetWidth; box.classList.add('eos-flash'); }

  function start() {
    modal = document.querySelector('[data-eos-modal]');
    if (modal) {
      wire(modal, function (g) {
        closeModal();
        var finder = document.querySelector('[data-eos-finder]');
        if (finder) {
          var box = finder.querySelector('[data-eos-results]');
          if (box) { render(box, g, false); flash(box); finder.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          return;
        }
        if (!/\/products\//.test(location.pathname))
          getMatches(g).then(function (l) { if (l.length === 1) window.location.href = '/products/' + l[0].h; });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      var x = modal.querySelector('[data-eos-close]');
      if (x) x.addEventListener('click', closeModal);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-eos-change]') : null;
      if (t) { e.preventDefault(); openModal(); return; }
      var c = e.target.closest ? e.target.closest('[data-eos-clear]') : null;
      if (c) {
        e.preventDefault(); clear(); paintGarage();
        document.querySelectorAll('[data-eos-results]').forEach(function (b) { b.innerHTML = ''; });
      }
    });
    document.querySelectorAll('[data-eos-finder]').forEach(function (root) {
      root.setAttribute('data-eos-mode', MODE);
      wire(root, function (g) {
        var box = root.querySelector('[data-eos-results]');
        if (!box) return;
        render(box, g, root.hasAttribute('data-eos-jump'));
        flash(box);
        if (box.getBoundingClientRect().bottom > window.innerHeight)
          box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      var g = get(), box = root.querySelector('[data-eos-results]');
      if (g && box && root.hasAttribute('data-eos-auto')) render(box, g, false);
    });
    document.querySelectorAll('[data-eos-browse]').forEach(paintBrowse);
    paintGarage();
  }

  function boot() {
    pull(ENDPOINT).then(function (j) {
      var f = filterOf(j, P_YEAR);
      if (f && f.values && f.values.length) { MODE = 'live'; BOOT = j; }
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.EOSGarage = { get: get, set: set, clear: clear, open: openModal,
                       mode: function () { return MODE; }, matches: getMatches };
})();
